module.exports = __webpack_public_path__ + "img/logo_black.f0485db3.png";